import { useCallback } from "react";

export function useScrollToPageTop(): (behavior?: "auto" | "instant" | "smooth") => void {
  return useCallback((behavior = "smooth") => {
    const mainEl = document.getElementsByTagName("main")[0];
    mainEl.scrollTo({ top: 0, behavior });
  }, []);
}
